import styled from '../../../styles/theme';
import { ToggleStyled } from '../ToggleStyled';
import { rem } from 'polished';

export const ToggleStyledDS = styled(ToggleStyled)`
    .toggleHandleContainer {
        background-color: transparent;
        border: 1px solid transparent;
        background-image: linear-gradient(#fff, #fff);
        background-size: 2px 100%;
        background-repeat: no-repeat;
        background-position: center center;
        top: ${rem('5px')};
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 30px;

        &Filter {
            transform: ${({ isHorizontal }) => (isHorizontal ? 'rotate(90deg)' : 'none')};
            background-image: linear-gradient(
                ${({ theme }) => theme.colors.black1},
                ${({ theme }) => theme.colors.black1}
            );
        }
    }

    .toggleHandle {
        background-color: ${({ theme }) => theme.colors.white};
        border-radius: 0%;
        transform: rotate(45deg)
            ${({ isHorizontal }) => (isHorizontal ? 'translate(50%, 50%)' : 'translate(-50%, -50%)')};
        width: 0.8rem;
        height: 0.8rem;

        &Filter {
            background-color: ${({ theme }) => theme.colors.black1};
        }

        &.toggled {
            transform: rotate(45deg) ${({ isHorizontal }) => (isHorizontal ? 'translate(-100%, 0)' : 'translate(0, 0)')};
        }
    }

    .toggleOption {
        color: ${({ theme }) => theme.colors.grey5};
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        font-size: ${rem('13px')};

        &.toggled {
            color: ${({ theme }) => theme.colors.black1};
            font-weight: bold;
        }
    }
`;
